//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ModalItem from './ModalItem';
import EmptyContent from '@nextcloud/vue/dist/Components/EmptyContent';
import moment from 'moment';
import JsonCSV from 'vue-json-csv';
export default {
  name: 'DataTable',
  filters: {
    formatMyDate: function formatMyDate(v) {
      // return new Date(v).toLocaleDateString() === new Date().toLocaleDateString() ? t('health', 'today') : new Date(v).toLocaleDateString()
      // console.debug('is valid date', { date: moment(v), valid: moment(v).isValid() })
      return moment(v) === moment() ? t('health', 'today') : moment(v).format('lll');
    },
    formatMyDatetime: function formatMyDatetime(v) {
      return moment(v).format('L') === moment().format('L') ? t('health', 'today') + ' ' + moment(v).format('LT') : moment(v).format('lll'); // const date = new Date(v).toLocaleDateString() === new Date().toLocaleDateString() ? t('health', 'today') : new Date(v).toLocaleDateString()
      // return date + ' ' + new Date(v).toLocaleTimeString().slice(0, 5)
    }
  },
  components: {
    ModalItem: ModalItem,
    EmptyContent: EmptyContent,
    JsonCSV: JsonCSV
  },
  props: {
    header: {
      type: Array,
      default: null
    },
    data: {
      type: Array,
      default: null
    },
    entityName: {
      type: String,
      default: t('health', 'item', {})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      range: 'week'
    };
  },
  computed: {
    datasets: function datasets() {
      var _this = this;

      var d = []; // console.debug('try to return', this.data)

      this.data.forEach(function (item) {
        var dateColumnId = '';
        dateColumnId = 'datetime' in item ? 'datetime' : dateColumnId;
        dateColumnId = 'date' in item ? 'date' : dateColumnId;
        dateColumnId = 'asleep' in item ? 'asleep' : dateColumnId;

        if (_this.isInTimeRange(item[dateColumnId])) {
          // console.debug('is in timerange', item)
          d.push(item);
        } else {// console.debug('not in range', item)
        }
      });
      return d;
    },
    rangeDays: function rangeDays() {
      if (this.range === 'week') {
        return 7;
      } else if (this.range === 'month') {
        return 31;
      } else if (this.range === 'year') {
        return 365;
      } else {
        return -1;
      }
    },
    getExportData: function getExportData() {
      var _this2 = this;

      if (!this.datasets && this.datasets.length > 0 && !this.header) {
        console.debug('error datasets', this.datasets);
        return [];
      }

      var data = [];
      this.datasets.forEach(function (d) {
        var item = {};

        _this2.header.forEach(function (h) {
          if (h.show) {
            item[h.columnId] = d[h.columnId];
          }
        });

        data.push(item);
      });
      return data;
    }
  },
  methods: {
    isInTimeRange: function isInTimeRange(date) {
      if (this.rangeDays !== -1) {
        // console.debug('diff', Math.abs(moment(date).diff(moment(), 'days')))
        return Math.abs(moment(date).diff(moment(), 'days')) <= this.rangeDays;
      } else {
        return true;
      }
    },
    calcCount: function calcCount(items) {
      return items.length;
    },
    deleteItem: function deleteItem(id) {
      this.$emit('deleteItem', this.datasets[id]);
    },
    handleDataIncome: function handleDataIncome(item) {
      if ('id' in item) {
        console.debug('id found -> update item', item);
        this.updateItem(item);
      } else {
        console.debug('id not found -> add item', item);
        this.addItem(item);
      }
    },
    addItem: function addItem(item) {
      this.$emit('addItem', item);
    },
    updateItem: function updateItem(item) {
      this.$emit('updateItem', item);
    }
  }
};